<template>
  <div class="qrcodePay">
    <el-dialog
      :visible.sync="visible"
      width="400px"
      :before-close="handleClose"
    >
      <template #title>
        <div class="title">
          <img src="../../../static/other/icon-wechatPay.png"/>
          <span>微信支付</span>
        </div>
      </template>
      <p class="sub-title">鼎函电子保函平台</p>
      <div v-loading="loading">
        <div class="qrcode" :style="{ visibility: qrCodeVisibility }">
          <div class="QRCodeDiv">
            <div class="imgDiv">
              <div class="imgDivBox">
                <div id="weChatQrcode" ref="weChatQrcode" :style="weChatExpire === true ? 'filter: blur(4px)' : ''"></div>
                <div class="login-img" v-if="!weChatExpire"><img src="../../assets/logo-ding.png"/></div>
                <div v-if="weChatExpire === true">
                  <div class="expire">
                    <span class="el-icon-refresh" @click="refreshOrder">刷新</span>
                  </div>
                  <div class="invalid">二维码已失效</div>
                </div>
              </div>
            </div>
            <div class="messageDiv">
              <p>干货分享每条收费 5 元 </p>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {webWeChatPrepay} from "@/api/basic";
import QRCode from 'qrcodejs2'
export default {
  name: "qrcodePay",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    itemId: {
      type: Number,
      default: 0
    },
    payNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      weChatExpire: false, // 二维码是否失效
      expireTime: null, // 二维码失效时间
      loading:true,
      fee: null
    };
  },
  computed: {
    qrCodeVisibility() {
      return this.loading ? 'hidden' : 'visible';
    },
  },
  methods: {
    handleClose() {
      this.$emit("close",this.itemId);
    },
    async getQrcodeUrl() {
      clearInterval(this.timer);
      this.weChatExpire = true;
      const res = await webWeChatPrepay({payNo: this.payNo})
      const {resultCode,data} = res.data
      if (resultCode === '200' && data) {
         this.$nextTick(()=>{
           document.getElementById("weChatQrcode").innerHTML = "";
           const {codeUrl,expireTime,fee} = data
           this.weChatQrcode = new QRCode("weChatQrcode", {
             width: 200,
             height: 200,
             text: codeUrl,
             colorDark: "#000",
             colorLight: "#fff",
           });
           this.weChatExpire = false;
           this.loading = false;
           this.expireTime = new Date(expireTime); //二维码失效时间
           console.log('expireTime',this.expireTime)
           this.fee = fee;
           this.loopCheckExpire();
         })
      } else {
        this.$message.error('获取微信支付二维码失败!');
      }
    },
    refreshOrder() {
      this.getQrcodeUrl()
    },
    loopCheckExpire() {
      this.timer = setInterval(() => {
        const now = new Date();
        if (now > this.expireTime) {
          this.weChatExpire = true;
          this.fee = null;
          clearInterval(this.timer);
        }
      }, 1000);
    }
  },
  mounted() {
    this.getQrcodeUrl()
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
}
</script>
<style>
.qrcodePay .el-dialog__body{
  padding: 0;
}
.qrcodePay .el-dialog__header .title{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 18px;
  font-weight: 500;
}

.qrcodePay .el-dialog__header .title img{
  width: 24px;
  margin-right: 4px;
}
.qrcodePay .sub-title {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  color: #606266;
  margin-top: 10px;
}
.qrcodePay .qrcode {
  text-align: center;
  position: relative;
}
.qrcodePay .qrcode img {
  width: 200px;
  height: 200px;
}
.qrcodePay .el-dialog__footer{
    text-align: center;
}
.qrcodePay .QRCodeDiv .imgDiv {
  height: 200px;
  width: 200px;
  margin: 20px auto 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.qrcodePay .QRCodeDiv .imgDiv .imgDivBox {
  width: 200px;
  height: 200px;
  position: relative;
}
.qrcodePay .QRCodeDiv .imgDiv img {
  width: 200px;
  height: 200px;
}
.qrcodePay .qrcode .imgDiv .login-img {
  position: absolute;
  top:0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  padding: 5px;
  width: 30px;
  height: 30px;
  background-color: #ffffff;
}
.qrcodePay .qrcode .imgDiv .login-img img {
  width: 100%;
  height:100%;
  background: #FFFFFF;
}
.qrcodePay .QRCodeDiv .imgDiv .expire {
  width: 200px;
  height: 200px;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
}
.qrcodePay .QRCodeDiv .imgDiv .invalid {
  color: #f73838;
  margin-top: 10px;
}
.qrcodePay .QRCodeDiv .imgDiv .expire span {
  color: #409EFF;
  font-size: 16px;
  background-color: #fff;
  border-radius: 15px;
  padding: 5px;
  border: 1px #409EFF solid;
  cursor: pointer;
 }
.qrcodePay .QRCodeDiv .messageDiv {
  text-align: center;
  font-size: 16px;
  margin-bottom: 10px;
}
</style>
